import { useContext } from "react";
import { NomenclaturesContext } from "../contexts/NomenclaturesContext";

export const useNomenclaturesContext = () => useContext(NomenclaturesContext);